<button class="btn buttonSecondary" (click)="clicked()">
    <span class="btn-icon" *ngIf="icono">
        <svg [class]="icono">
            <use [attr.xlink:href]="icono|iconoRef"></use>
        </svg>
    </span>
    <span class="btn-text">{{titulo}}</span>
</button>
